// extracted by mini-css-extract-plugin
export default {"terms_content":"privacy_terms_content__7wL8a","terms_heading":"privacy_terms_heading__ou66Y"};